import { StateDataEnum } from '@ysura/common';

import { createEnumMapperFunction } from '@/services/graphql/mappers/utils';
import { State } from '@/services/graphql/types';

export const mapperToStateDataEnum = createEnumMapperFunction(
  State,
  StateDataEnum
);
